import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Airport } from './model/Airport';
import { endpoints } from '../../../environments/endpoint';
import { Administrator } from './model/Administrator';
import { AirportAdministrator } from './model/AirportAdministrator';
import { FtpSita } from './model/FtpSita';
import { AirportSita } from './model/AirportSita';
import { DateService } from '../../app-conciliation/conciliation/service/date.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
  })
};

@Injectable({
  providedIn: 'root'
})
export class AppModalAdministratorSitaService {

  constructor(private http: HttpClient,private dateService: DateService) { }

  public getListAirport(): Observable<AirportSita[]> {
    let url = endpoints.REST_GTECLOUD_GET_AIRPORTS_SITA;
    return this.http.get<AirportSita[]>(url, httpOptions);
  }

  public getListAirportNotExistAdministrator(): Observable<Airport[]> {
    let url = endpoints.REST_GTECLOUD_GET_AIRPORTS_SITA + endpoints.REST_GTECLOUD_GET_NOT_EXIST;
    return this.http.get<Airport[]>(url, httpOptions);
  }

  public removeAirportAdministrator(airportSita: AirportSita): Observable<string> {
    const airportSitaId = {
      airportId: airportSita.airportCode.id,
      administratorId: airportSita.administratorAirport.identification,
    };

    return this.http.delete(endpoints.REST_GTECLOUD_GET_AIRPORTS_SITA, {
      headers: httpOptions.headers,
      body: airportSitaId,
      responseType: 'text',
    });
  }

  public getAdministratorAirport(code: number): Observable<Administrator> {
    let restTemplate = endpoints.REST_GTECLOUD_GET_ADMINISTRATORS_AIRPORTS + endpoints.REST_GTECLOUD_COMPLEMENT_ID;
    restTemplate = restTemplate.replace('{id}',(code +''));
    return this.http.get<Administrator>(restTemplate, httpOptions);
  }

  public getFtpSita(): Observable<FtpSita> {
    return this.http.get<FtpSita>(endpoints.REST_GTECLOUD_GET_FTP_SITA, httpOptions);
  }

  public saveAirportAdministratorCode(airportCode: number): Observable<AirportSita> {
    let restTemplate = endpoints.REST_GTECLOUD_GET_AIRPORTS_SITA + endpoints.REST_GTECLOUD_COMPLEMENT_ID;
    restTemplate = restTemplate.replace('{id}', (airportCode + ''));
    return this.http.post<AirportSita>(restTemplate, null, httpOptions);
  }

}
